import camelCase from 'lodash/camelCase';
import { Category, Color, Shade, Tier } from '../enums';
export function getEnumAsClass(enumVal) {
  return camelCase(enumVal === null || enumVal === void 0 ? void 0 : enumVal.toLowerCase());
}
export function colorEnumToCategory(enumVal) {
  switch (enumVal) {
    case Color.RED:
      return Category.DANGER;

    case Color.GREEN:
      return Category.SUCCESS;

    case Color.ORANGE:
      return Category.WARNING;

    case Color.BLUE:
      return Category.INFO;

    case Color.BRAND:
      return Category.BRAND;

    case Color.PRIMARY:
      return Category.PRIMARY;
  }
}
export function categoryEnumToColor(enumVal) {
  switch (enumVal) {
    case Category.DANGER:
      return Color.RED;

    case Category.SUCCESS:
      return Color.GREEN;

    case Category.WARNING:
      return Color.ORANGE;

    case Category.INFO:
      return Color.BLUE;

    case Category.BRAND:
      return Color.BRAND;

    case Category.PRIMARY:
      return Color.PRIMARY;
  }
}
export function shadeEnumToTier(enumVal) {
  switch (enumVal) {
    case Shade.DARK:
      return Tier.PRIMARY;

    case Shade.MEDIUM:
      return Tier.SECONDARY;

    case Shade.LIGHT:
      return Tier.TERTIARY;
  }
}
export function getIconForCategory(category) {
  switch (category) {
    case Category.DANGER:
      return 'alert-circle';

    case Category.SUCCESS:
      return 'check-circle';

    case Category.WARNING:
      return 'alert-triangle';

    default:
      return 'info';
  }
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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